"use client";
import Tabs from "@/components/primitives/tabs";
import React from "react";
import { useRouter } from "next-nprogress-bar";
import { usePathname } from "next/navigation";
import { CurrentSeason } from "common";
import { TeamProfileParams } from "../../layout";
import { useParamUpdater } from "@/utils/hooks/navigation";

export default function TeamScheduleFilter({ currentSeason, params }: { currentSeason: CurrentSeason; params: TeamProfileParams & { view?: string[] } }) {
  const router = useRouter();

  const pathname = usePathname();
  const { createParamString } = useParamUpdater();
  const view = params.view?.[0] ? params.view?.[0] : (params.year !== `${currentSeason.current.year}` || currentSeason.current.season === 4) ? "past-games" : "upcoming"

  return (
    <Tabs
      variant="pill"
      onValueChange={(v) => {
          router.replace(createParamString(v, 5) || pathname, {
            scroll: false,
          });
      }}
      label="Team Schedule View"
      value={view}
      items={[
        {
          label: "Upcoming",
          value: "upcoming",
        },
        {
          label: "Past Games",
          value: "past-games",
        },
      ]}
    />
  );
}
